"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var CashBatch = function CashBatch(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M18.521 11.119a1 1 0 011 1v6.98a1 1 0 01-1 1H5a1 1 0 01-1-1v-6.98a1 1 0 011-1h13.521zm-1.965 1.192H6.98v.02c0 .975-.79 1.767-1.766 1.768h-.022v3.295a1.768 1.768 0 011.747 1.51h9.63a1.768 1.768 0 011.748-1.505v-3.26a1.768 1.768 0 01-1.761-1.828zm-4.79.898c.477 0 .93.208 1.24.57a2.93 2.93 0 01.565 1.816 3.078 3.078 0 01-.507 1.754c-.3.413-.782.655-1.293.648a1.592 1.592 0 01-1.355-.703 2.507 2.507 0 01-.365-.887 4.041 4.041 0 01-.077-.815 3.522 3.522 0 01.184-1.168c.085-.234.21-.453.368-.645.31-.362.764-.57 1.24-.57zM6.068 6.693l.093.012 12.498 2.696a.578.578 0 01.443.688l-.034.155a.478.478 0 01-.464.375h-1.751a.478.478 0 01-.478-.554l.014-.05-8.4-1.821v.024a1.587 1.587 0 01-1.887 1.214h-.017l-.167.772a.542.542 0 01-.529.425l-.096-.009a.538.538 0 01-.43-.643l.612-2.83a.578.578 0 01.686-.442zm4.874 3.386c.32-.202.708-.267 1.079-.179.205.041.399.125.569.246a.265.265 0 01-.158.478h-1.434a.263.263 0 01-.172-.463zM7.178 4.35a.578.578 0 01.758-.306L17.35 8.03a.578.578 0 01.332.655l-2.15-.478L9.08 5.472v.017a1.295 1.295 0 01-1.7.688h-.014l-.1.263-.105-.031a.74.74 0 01-.421-.982z"
  }));
};

var _default = (0, _react.forwardRef)(CashBatch);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CashBatch, "CashBatch", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CashBatch.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CashBatch.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();